module.exports = __webpack_public_path__ + "media/common/fonts/social/social-58f712e0007f67663093238a21b51788.eot";